<div *ngIf="!isRevisionNoticesPage" [ngClass]="!isInnerBorder ? 'section-border' : ''">
  <div *ngFor="let section of sections; let i = index" [ngClass]="isInnerBorder ? 'section-border' : ''">
    <h4 id="{{ i }}" [ngClass]="isSelected(i) ? 'highlight' : ''">{{ section.title }}</h4>
    <div [innerHTML]="section.body | mdToHtml"></div>
    <br *ngIf="!isInnerBorder" />
  </div>
</div>

<div *ngIf="isRevisionNoticesPage">
  <div *ngFor="let section of sections">
    <h2>{{ section.title }}</h2>
    <div class="section-border revision-notices-page-section">
      <div [innerHTML]="section.body | mdToHtml"></div>
    </div>
  </div>
</div>
